/*
  SAVRA cart drawer — progressive enhancement over /cart. The cart icon
  stays a real <a href="{{ routes.cart_url }}">; this only intercepts the
  click once it has successfully initialized. If anything here throws,
  the anchor's native href still navigates to /cart normally.
*/
(function () {
  'use strict';

  function trapFocus(container, onEscape) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function handleKeydown(e) {
      if (e.key === 'Escape' && onEscape) { onEscape(); return; }
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handleKeydown);
    return function () { container.removeEventListener('keydown', handleKeydown); };
  }

  var CartDrawer = /** @class */ (function () {
    function CartDrawer(root) {
      this.root = root;
      this.panel = root.querySelector('[data-cart-drawer-panel]');
      this.content = root.querySelector('[data-cart-drawer-content]');
      this.closeBtn = root.querySelector('[data-cart-drawer-close]');
      this.scrim = root.querySelector('[data-cart-drawer-scrim]');
      this.trigger = document.getElementById('CartIcon');
      this.releaseFocusTrap = null;
      this.bind();
      window.savraCartDrawer = this;
    }

    CartDrawer.prototype.bind = function () {
      var self = this;
      if (this.trigger) {
        this.trigger.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      }
      this.closeBtn.addEventListener('click', function () { self.close(); });
      this.scrim.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.panel.classList.contains('is-open')) self.close();
      });
      this.root.addEventListener('click', function (e) {
        var removeEl = e.target.closest('[data-cart-remove]');
        if (removeEl) {
          e.preventDefault();
          self.changeLine(removeEl.getAttribute('data-line'), 0);
        }
      });
      this.root.addEventListener('change', function (e) {
        if (e.target.matches('[data-quantity-input]')) {
          self.changeLine(e.target.getAttribute('data-line'), e.target.value);
        }
      });
    };

    CartDrawer.prototype.open = function () {
      if (window.__savraCloseDrawer) window.__savraCloseDrawer();
      if (window.__savraCloseSearch) window.__savraCloseSearch();
      if (window.__savraCloseAllMega) window.__savraCloseAllMega();
      if (window.savraNewsletterOverlay) window.savraNewsletterOverlay.close();

      var self = this;
      this.panel.classList.add('is-open');
      this.scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.closeBtn.focus();
      this.releaseFocusTrap = trapFocus(this.panel, function () { self.close(); });
      this.refresh();
    };

    CartDrawer.prototype.close = function () {
      this.panel.classList.remove('is-open');
      this.scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.releaseFocusTrap) this.releaseFocusTrap();
      if (this.trigger) this.trigger.focus();
    };

    CartDrawer.prototype.refresh = function () {
      var self = this;
      return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) { self.renderContent(html); })
        .catch(function () { self.showError(); });
    };

    CartDrawer.prototype.changeLine = function (line, quantity) {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart update failed');
          return r.json();
        })
        .then(function (cart) {
          if (cart.sections && cart.sections['cart-drawer']) self.renderContent(cart.sections['cart-drawer']);
          self.updateHeaderCount(cart.item_count);
        })
        .catch(function () { self.showError(); });
    };

    CartDrawer.prototype.renderContent = function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newContent = doc.querySelector('[data-cart-drawer-content]');
      var newFooter = doc.querySelector('.sav-cart-drawer-footer');
      var currentFooter = this.panel.querySelector('.sav-cart-drawer-footer');
      if (newContent) this.content.innerHTML = newContent.innerHTML;
      if (currentFooter) currentFooter.remove();
      if (newFooter) this.panel.insertBefore(newFooter, null);
      var newCount = doc.querySelector('[data-cart-count]');
      if (newCount) this.updateHeaderCount(newCount.textContent.trim());
    };

    CartDrawer.prototype.updateHeaderCount = function (count) {
      var el = document.querySelector('[data-cart-count]');
      if (!el) return;
      el.textContent = count;
      el.hidden = Number(count) === 0;
      if (this.trigger) this.trigger.setAttribute('aria-label', count + ' items in bag');
    };

    CartDrawer.prototype.showError = function () {
      var existing = this.content.querySelector('[data-cart-drawer-error]');
      if (existing) return;
      var el = document.createElement('p');
      el.className = 'sav-cart-drawer-error';
      el.setAttribute('data-cart-drawer-error', '');
      el.setAttribute('role', 'alert');
      el.textContent = 'Something went wrong updating your bag. View bag to try again.';
      this.content.prepend(el);
    };

    return CartDrawer;
  })();

  document.querySelectorAll('cart-drawer').forEach(function (el) {
    new CartDrawer(el);
  });
})();
